import angular from 'angular';
import uiRouter from 'angular-ui-router';
import benefitRequestCardComponent from './benefitRequestCard.component';
import BenefitDaysRequestSwitch from './BenefitDaysRequestSwitch/benefitDaysRequestSwitch';

let benefitRequestCardModule = angular.module('benefitRequestCard', [
  uiRouter,
  BenefitDaysRequestSwitch,
])

.component('benefitRequestCard', benefitRequestCardComponent)

.name;

export default benefitRequestCardModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestList/benefitRequestCard/benefitRequestCard.js